import SimpleTableHelpDialog from "./commons/SimpleTableHelpDialog";

export default function AthensInsomniaScaleHelpDialog() {
  return (
    <SimpleTableHelpDialog
      title="アテネ不眠尺度の説明"
      explain={{
        title: "アテネ不眠尺度（AIS）とは",
        content:
          "不眠の重症度を評価するための質問紙としてICD-10の診断基準に基づき作成された指標です。全8問で構成され、各問0～3点で合計得点を算出し、6点以上を不眠症のカットオフ点としています。",
      }}
      table={{
        title: "アテネ不眠尺度の重症度",
        records: [
          ["アテネ不眠尺度の点数", "重症度"],
          ["0-5点", "正常"],
          ["6-9点", "軽症の不眠症が疑われます"],
          ["10-15点", "中等症の不眠症が疑われます"],
          ["16-24点", "重症の不眠症が疑われます"],
        ],
      }}
      reference="臨床睡眠検査マニュアル（日本睡眠学会）"
    />
  );
}
